<template>
    <div class="side-bar d-flex flex-column" :class="{ active: show }">
        <button class="side-bar-close" @click="closeSideBar">
            <i class="fal fa-times"></i>
        </button>
        <div class="side-bar-logo">
            <a :href="homeURL">
                <img
                    :src="
                        require(`@/assets/images/themes/${theme.folderName}/logo.svg`)
                    "
                    alt="Logo"
                />
            </a>
        </div>
        <div class="side-bar-menu" :class="{ active: sidebarActive }">
            <ul class="main-menu">
                <li v-for="(item, index) in menu" :key="index">
                    <router-link
                        :to="item.link"
                        :class="{
                            active: isActive(item.link.name),
                        }"
                        @click.native="closeSideBar"
                    >
                        <div v-if="item.icon" class="icon">
                            <img
                                :src="item.icon.active"
                                :alt="item.label"
                                class="icon-active"
                            />
                            <img
                                :src="item.icon.inactive"
                                :alt="item.label"
                                class="icon-inactive"
                            />
                        </div>
                        <span> {{ $t(item.labelTranslationKey) }} </span>
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { THEMES } from '@/constants/config';
import { mapState } from 'vuex';

export default {
    name: 'SideBar',
    props: {
        menu: {
            type: Array,
            required: true,
        },
        noPrefix: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            sidebarActive: false,
            body: document.querySelector('body'),
            theme:
                THEMES[process.env.VUE_APP_THEME?.toUpperCase()] ||
                THEMES.DEFAULT,
        };
    },
    watch: {
        show(val) {
            this.toggleBodyStyle(val);
        },
    },
    computed: {
        ...mapState('nav', ['show']),
        homeURL() {
            return this.$helpers.homeURL();
        },
    },
    methods: {
        closeSideBar() {
            this.$store.commit('nav/closeSidebar');
        },
        getPrefix(routeName) {
            return routeName.split('.')[0];
        },
        isActive(routeName) {
            return this.noPrefix
                ? this.$route.name === routeName
                : this.getPrefix(this.$route.name) ===
                      this.getPrefix(routeName);
        },
        toggleBodyStyle(enable) {
            this.body.classList.toggle('overflow-hidden', enable);
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'SideBar';
</style>
